"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PING_ENDPOINT = exports.PONG_ENDPOINT = void 0;
exports.PONG_ENDPOINT = '/pong';
exports.PING_ENDPOINT = '/ping';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5kcG9pbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hhbmRzaGFrZS9lbmRwb2ludHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxhQUFhLEdBQUcsT0FBTyxDQUFDO0FBQ3hCLFFBQUEsYUFBYSxHQUFHLE9BQU8sQ0FBQyJ9